export default __webpack_public_path__ + "static/media/Pano copy 2.88072578.jpg";